import LightBoxLatestExample from "components/common/LightBoxLatestExample";
import { useFetchCategoryVariants } from "hooks/useFetchCategoryVariants";
import { useFetchVariants } from "hooks/useFetchDetailVariants";
import { useEffect, useMemo, useRef } from "react";
import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import Select from "react-select";
import { BASEURL } from "utils/customConfig";
import { useLocation } from "react-router-dom";
import { mapApiVariantsToUI } from "utils/functions";
import Swal from "sweetalert2";
import { MdOutlineLibraryAddCheck } from "react-icons/md";
import OverLayButton from "components/common/OverLayButton";
import { useEditData } from "../../EditContext";
const Variants = () => {
  const location = useLocation();
  const state = useEditData();
  const { watch, setValue } = useFormContext();
  const categoryId = watch("categoryId");

  const { data: variantsData, isLoading: variantsLoading } = useFetchVariants();
  const { data: categoryVariantsData, isLoading: categoryVariantsLoading } =
    useFetchCategoryVariants();

  // Filter category variants
  const filteredCategoryVariants = useMemo(() => {
    if (!categoryVariantsData || !categoryId) return [];
    return categoryVariantsData?.data?.data?.filter(
      (set) => set.categoryId === categoryId,
    );
  }, [categoryVariantsData, categoryId]);

  // Get variant IDs
  const variantsIds = useMemo(() => {
    return filteredCategoryVariants.flatMap((set) =>
      set.options.map((opt) => opt.variantId),
    );
  }, [filteredCategoryVariants]);

  // Filter variants
  const filteredVariantsOption = useMemo(() => {
    if (!variantsData || variantsIds.length === 0) return [];
    return variantsData?.data?.data?.filter((variant) =>
      variantsIds.includes(variant.id),
    );
  }, [variantsData, variantsIds]);

  const handleGenerate = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will update pricing and stock. All previous records will be overwritten.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // trigger regeneration
        setValue("generatePermutations", Date.now());
      }
    });
  };

  console.log("filteredVariantsOption", filteredVariantsOption);

  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current) return;

    if (!filteredVariantsOption.length) return;

    const savedSelections = state?.productVariants
      ? mapApiVariantsToUI(state.productVariants)
      : {};

    const initialVariants = [
      {
        name: "Variant One",
        sortOrder: 0,
        status: true,
        options: filteredVariantsOption.flatMap((variant) =>
          variant.options.map((opt) => ({
            variantId: opt.id,
            name: opt.name,
            allOptions: opt.options || [],
            options: savedSelections[opt.name] || [],
            optionImages: opt.optionImages || [],
          })),
        ),
      },
    ];

    setValue("productVariants", initialVariants);
    initializedRef.current = true;
  }, [filteredVariantsOption, setValue]);

  // useEffect(() => {
  //   if (!filteredVariantsOption.length) {
  //     setValue("productVariants", []);
  //     return;
  //   }

  //   const savedSelections = state?.productVariants
  //     ? mapApiVariantsToUI(state.productVariants)
  //     : {};

  //   const initialVariants = [
  //     {
  //       name: "Variant One",
  //       sortOrder: 0,
  //       status: true,
  //       options: filteredVariantsOption.flatMap((variant) =>
  //         variant.options.map((opt) => ({
  //           variantId: opt.id,
  //           name: opt.name,
  //           allOptions: opt.options || [],
  //           options: savedSelections[opt.name] || [],
  //           optionImages: opt.optionImages || [],
  //         }))
  //       ),
  //     },
  //   ];

  //   setValue("productVariants", initialVariants);
  // }, [filteredVariantsOption, state, setValue]);

  const variants = watch("productVariants") || [];

  console.log("variants", variants);

  if (variantsLoading || categoryVariantsLoading) {
    return (
      <div className="d-flex py-3 justify-content-center align-items-center">
        <Button variant="falcon-default" size="sm">
          Loading...
        </Button>
      </div>
    );
  }

  return (
    <>
      {/* {variants?.length > 0 && <>
        <div className="d-flex justify-content-end">

          <Button
            variant="primary"
            className="mb-3 "
            onClick={handleGenerate}
          >
            Update
          </Button>
        </div>
      </>} */}
      <div className="px-3">
        {Array.isArray(variants) &&
          variants.map((variant, variantIndex) => (
            <Row key={variant.id} className="mb-3">
              {/* <Card.Header as="h6" className="bg-body-tertiary text-800">
              {variant.name}
            </Card.Header> */}

              <Card.Body style={{ padding: 0 }}>
                <Table>
                  <thead className="bg-200">
                    <tr>
                      <th className="fs-10" style={{ width: "30%" }}>
                        Name
                      </th>
                      <th className="fs-10" style={{ width: "30%" }}>
                        Options
                      </th>
                      {/* <th className="fs-10" style={{ width: "5%" }}></th> */}
                      <th className="fs-10" style={{ width: "30%" }}>
                        Images
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {variant.options.map((item, optionIndex) => {
                      const fieldName = `productVariants.${variantIndex}.options.${optionIndex}.options`;
                      console.log("filedName: ", fieldName);
                      const selectedValues = watch(fieldName) || [];

                      console.log(selectedValues);

                      // Use allOptions for the dropdown
                      const selectOptions = (item.allOptions || []).map(
                        (opt) => ({ label: opt, value: opt }),
                      );

                      return (
                        <tr key={optionIndex}>
                          <td style={{ padding: "1px" }}>
                            <Form.Control
                              className="fs-10 py-2"
                              value={item.name}
                              disabled
                            />
                          </td>

                          <td style={{ padding: "1px" }}>
                            <Select
                              isMulti
                              isClearable
                              closeMenuOnSelect={false}
                              menuPlacement="auto"
                              menuPortalTarget={document.body}
                              placeholder="Select options"
                              options={selectOptions} // always full list
                              value={selectOptions.filter((opt) =>
                                selectedValues.includes(opt.value),
                              )}
                              onChange={(selected) => {
                                const values = selected
                                  ? selected.map((s) => s.value)
                                  : [];
                                setValue(fieldName, values, {
                                  shouldDirty: true,
                                });
                              }}
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  fontSize: "13px", // input text
                                }),
                                option: (base) => ({
                                  ...base,
                                  fontSize: "13px", // dropdown options
                                }),
                                multiValueLabel: (base) => ({
                                  ...base,
                                  fontSize: "13px", // selected chips text
                                }),
                                placeholder: (base) => ({
                                  ...base,
                                  fontSize: "13px",
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  fontSize: "13px",
                                }),
                              }}
                            />
                          </td>
                          {/* <td style={{ padding: "1px" }}>
                            <OverLayButton
                              toolTip="Update Pricing and Stock"
                              icon={<MdOutlineLibraryAddCheck />}
                              onClick={handleGenerate}
                            />
                          </td> */}
                          <td style={{ padding: "1px" }}>
                            <LightBoxLatestExample
                              images={
                                item.optionImages
                                  ?.filter(Boolean)
                                  .map((m) => BASEURL + "/wwwroot" + m) || []
                              }
                            >
                              {(setImgIndex) => (
                                <Row className="g-2">
                                  {item.optionImages
                                    ?.filter(Boolean)
                                    .map((img, imgIndex) => (
                                      <Col xs={6} md={4} lg={1} key={imgIndex}>
                                        <img
                                          src={BASEURL + "/wwwroot" + img}
                                          width="100%"
                                          // height={50}
                                          className="pr-2"
                                          style={{
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => setImgIndex(imgIndex)}
                                        />
                                      </Col>
                                    ))}
                                </Row>
                              )}
                            </LightBoxLatestExample>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Card.Body>
            </Row>
          ))}
      </div>
    </>
  );
};

export default Variants;
